export function stdTooltip(text) {
    return { "data-tooltip-id": "tooltip", "data-tooltip-content": text };
}
